import { useQuery } from '@tanstack/react-query';
import { useApi } from './client.js';

export interface McpInvocation {
  label: string;
  command: string;
  args: string[];
  hint: string;
}

export interface McpTool {
  name: string;
  category: 'discovery' | 'iteration' | 'authoring' | 'operations';
  description: string;
}

export interface McpEnv {
  name: string;
  required: boolean;
  description: string;
}

export interface McpHttpTransport {
  url: string;
  authHeader: string;
  authScheme: string;
  alternateAuthHeader: string;
  notes: string;
}

export interface McpStdioTransport {
  invocations: McpInvocation[];
}

export interface McpInfo {
  serverName: string;
  serverVersion: string;
  /** Present in CSAGE-85+ deploys. Older API responses omit; check before use. */
  transport?: {
    http: McpHttpTransport;
    stdio: McpStdioTransport;
  };
  /** @deprecated Use transport.stdio.invocations. Kept for back-compat. */
  invocations: McpInvocation[];
  tools: McpTool[];
  requiredEnv: McpEnv[];
  docsPath: string;
}

export function useMcpInfo() {
  const api = useApi();
  return useQuery<McpInfo>({
    queryKey: ['mcp-info'],
    queryFn: () => api.fetch('/authoring/mcp-info'),
    staleTime: 5 * 60 * 1000,
  });
}
